import { Image, LI, UL } from "../../../AbstractElements";
import { Href } from "../../../Constant";
import { EMAIL_APP_IMAGES } from "../../../Data/Email";
import { dynamicImage } from "../../../Service/DynamicImage";

const Attachment = () => {
  const images = [1, 2, 3];
  return (
    <>
      <div className="attachment">
        <UL className="flex-row simple-list">
          {images.map((item, index) => (
            <LI className="list-inline-item m-2" key={index}>
              <Image className="img-fluid" src={dynamicImage(`email/${item}.jpg`)} alt="image" />
            </LI>
          ))}
        </UL>
      </div>
      <hr />
      <div className="action-wrapper">
        <UL className="actions flex-row simple-list">
          {EMAIL_APP_IMAGES.map((item, index) => (
            <LI key={index}>
              <a className="text-muted" href={Href}>
                <i className={`fa fa-${item.icon} me-2`} />
                {item.text}
              </a>
            </LI>
          ))}
        </UL>
      </div>
    </>
  );
};

export default Attachment;
